import { theme } from '@mi-front/ui';
import styled from 'styled-components';

/**
 * Wrapper for the Stream component with consistent styling.
 */
export const StreamWrapper = styled.div`
  margin-right: auto;
  position: relative;
  overflow: hidden;
  border: 1px solid ${theme.gray200};
  border-radius: 8px;
  transition: all 0.1s;
  margin-left: 1rem;
`;
